import React from 'react';
import styles from './footerPrintOnly.module.scss';

const FooterPrintOnly = () => (
  <div className={styles.printOnlyFooter}>
    <span className={styles.printOnlyFooterText}>
      Copyright &copy; {new Date().getFullYear()} ECRI
    </span>
  </div>
);

export default FooterPrintOnly;
